import React from 'react';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
import MUITooltip from '@material-ui/core/Tooltip';
import copy from 'copy-to-clipboard';

import { Label } from 'core';
import { CopyButton } from 'core/components/copy-button';
import useStyles from './label-with-copy-button.styles';
import { useToast } from 'core/components/toast';

const LabelWithCopyButton = ({ children, editing, type, ...props }) => {
  const formatted = children.toString().replaceAll(',', '');
  const title = `Copy ${formatted} to clipboard`;
  const classes = useStyles();
  const toast = useToast();

  const onCopy = () => {
    const copied = copy(formatted);
    if (!copied) {
      toast.notify({
        type: 'error',
        message: `${formatted} could not be copied`
      });
    }
    return copied;
  };

  return (
    <Grid className={classes.container}>
      <MUITooltip title={title} arrow placement="top" classes={{ tooltip: classes.tooltip }}>
        <CopyButton onCopy={onCopy} className={classes.button} aria-label={title}>
          <Label type={type} {...props} className={classes.label}>
            {children}
          </Label>
        </CopyButton>
      </MUITooltip>
    </Grid>
  );
};

LabelWithCopyButton.propTypes = {
  children: PropTypes.node.isRequired
};

export default LabelWithCopyButton;
